import NextLink from "next/link";

import { Container } from "#ui/container";
import { Copyright, Footer, FooterNav } from "#ui/footer";
import { Logo } from "#ui/logo";

import { ButtonCookieSettings } from "./ButtonCookieSettings";
import { FooterLink } from "./FooterLink";
import { classNamesFooterLink } from "./footers-utils";

export function AuthorizedFooter() {
  return (
    <Footer className="py-100px text-shade-80">
      <Container className="space-y-30px">
        <NextLink href="/" className="block w-fit">
          <Logo layout="mark-only" size="md" />
        </NextLink>
        <FooterNav>
          <FooterLink
            href="https://www.rwbaird.com/help/privacy-notice/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </FooterLink>{" "}
          <FooterLink
            href="https://www.rwbaird.com/help/privacy-notice/#vertTab-5456"
            target="_blank"
            rel="noopener noreferrer"
          >
            Cookie Policy
          </FooterLink>{" "}
          <ButtonCookieSettings className={classNamesFooterLink} />{" "}
          <FooterLink href="/contact-us">Contact &amp; FAQs</FooterLink>
        </FooterNav>
        <Copyright />
      </Container>
    </Footer>
  );
}
